<template>
    <div>

        <el-form-item
            :label="currentField.label">
        </el-form-item>
        <div class="row">
            <div class="col-6 pdf-item" :componentvalue="currentField.firstNameValue">
                <el-form-item
                    :label="currentField.firstname"
                    :label-width="currentField.labelWidth + 'px'">
                    <el-input v-model="currentField.firstNameValue" v-bind="attributesBinding" v-on:change="firstNameChange">
                    </el-input>
                </el-form-item>
            </div>
            <div class="col-6 pdf-item" :componentvalue="currentField.lastname">
                <el-form-item
                    :label="currentField.lastname"
                    :label-width="currentField.labelWidth + 'px'">
                    <el-input v-model="currentField.lastNameValue" v-bind="attributesBinding" v-on:change="lastNameChange">
                    </el-input>
                </el-form-item>
                </div>
            </div>
        </div>
</template>


<script>
export default {
  name: 'Name',
  props: ['currentField'],
  data() {
    return {
    };
  },
  computed: {
    attributesBinding() {
      var attr = {};

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    }
  },
  methods: {
    firstNameChange(value) {
      this.currentField.firstNameValue = value.length == 0 ? '' : value;
      this.fullNameValue();
    },
    lastNameChange(value) {
      this.currentField.lastNameValue = value.length == 0 ? '' : value;
      this.fullNameValue();
    },

    fullNameValue() {
        let seprate =   this.currentField.firstNameValue.length != 0 || this.currentField.lastNameValue.length != 0  ? ',' : '';

        this.currentField.componentValue = this.currentField.firstNameValue + seprate + this.currentField.lastNameValue;
    },

    setNameValue() {
        let data = this.currentField.componentValue.indexOf(',');

        this.currentField.firstNameValue = this.currentField.componentValue.substr(0,data);
        this.currentField.lastNameValue = this.currentField.componentValue.substr(data+1 ,this.currentField.componentValue.length);
    },
  },
  mounted() {
    if (this.currentField.componentValue && this.currentField.componentValue.length > 0) {
        this.setNameValue();
    }
  }
};
</script>